import { Component, HostBinding } from '@angular/core';


@Component({
  selector: 'mui-card-actions',
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  template: `
    <ng-content select="[mui-btn]"></ng-content>
  `
})
export class MuiCardActions {
  @HostBinding('class') private readonly _class = 'mui-card__actions';
}
